<!-- Module 1  -->
<template>
  <div class="mentee-feedback">
    <div>
      <feedback-title :time="appDetail.mentorResultTimeStr"></feedback-title>
      <div class="mentee-feedback-con">
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label="To recap some of the highlights from today's meeting"
                    prop="highlights"
                    class="dis-30">
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.highlights"
                      :cache=false></editor>
            </div>
          </FormItem>
          <FormItem label="Example for industry program"
                    prop="bestQualities"
                    class="dis-30">
            <div class="mentee-feedback-item-title">
              <br /><br />
              --Leadership and extracurricular experience - you've shown great dedication and breadth --Quality of your internships: fanatatics, the brand names- Mckinse, Bain - are very marketable --Your overall balance between academic achievement and extracurriculars is great- you are very well-rounded and this is something that should be emphasized. As discussed, highlight that trend of increasing GPA year over year, and that it's been a learning process where you've quickly improved.</div>
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.bestQualities"
                      :cache=false></editor>
            </div>
          </FormItem>
          <FormItem label="Homework"
                    prop="homework"
                    class="dis-30">
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.homework"
                      :cache=false></editor>
            </div>
          </FormItem>
          <FormItem label="Suggested time for the next meeting"
                    prop="nextMeetingSuggested"
                    class="dis-30">
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.nextMeetingSuggested"
                      :cache=false></editor>
            </div>
          </FormItem>
          <!--  v-if="appDetail.videoType === 'ZOOM'" -->
          <div class="mentee-feedback-time">
            <spend-time :appDetail="appDetail"
                        :isPackageId="isPackageId"
                        @on-detail="sendRemainTime"></spend-time>
            <FormItem label=""
                      prop="timeSpent"
                      :class="['dis-30',
                      errorMsg?'':'mentee-appointment-feedback-error-msg']"
                      :show-message="errorMsg">
              <Input placeholder="Please fill out positive integer number of minutes"
                     v-model="formValidate.timeSpent"
                     @on-change="handleSendChange">
              <span slot="append">mins</span>
              </Input>
            </FormItem>
            <div class="error-msg"
                 v-if="!errorMsg">You have exceeded the maximum time allowance of a module, your exceeded time will not be remunerated！</div>
            <spend-time-tips></spend-time-tips>
          </div>
          <div class="mentee-feedback-btn">
            <Button class="zlr-btn-primary"
                    @click="handleSend"
                    :loading="isSub">Send</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
// components
import Editor from '_c/editor/editor'
import SpendTime from './feedback-spent-time'
import FeedbackTitle from './feedback-title'
// constant
import { promptInput } from '@/constant'
import { validateNumber } from '@/libs/validator'
import errorMixins from './mixins/feedback-error.js'
import SpendTimeMixins from './mixins/spent-time-show.js'
export default {
  name: 'mentee-feedback1',
  props: ['appDetail', 'isPackageId'],
  mixins: [errorMixins, SpendTimeMixins],
  components: {
    Editor,
    SpendTime,
    FeedbackTitle
  },
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        highlights: [{ required: true, message: promptInput }],
        bestQualities: [{ required: true, message: promptInput }],
        homework: [{ required: true, message: promptInput }],
        nextMeetingSuggested: [{ required: true, message: promptInput }],
        timeSpent: [{ required: true, message: promptInput }, { validator: validateNumber }]
      },
      isSub: false
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 提交feedback
    handleSend () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.appointmentId = this.appDetail.id
          this.isSub = true
          this.$emit('on-feedback', data)
        }
      })
    },
    handleComplete () {
      this.isSub = false
    }
  }
}
</script>
